import { getMethod } from "./api-service";

export const getCategoryFilterList = async (id) => {
    try {
        const response = await getMethod(`/category/${id}/filter-list`);
        return response;
    } catch (error) {
        console.log("Error: ", error);
        return { success: false, message: error };
    }
};

export const getSearchedColorList = async (query) => {
    try {
        if (!query) {
            return { success: true, data: [] };
        }

        const response = await getMethod(
            `/color/search?name=${encodeURIComponent(query)}`
        );

        return response;
    } catch (error) {
        console.log("Error: ", error);
        return { success: false, message: error };
    }
};

export const getCategoryList = async () => {
    try {
        const response = await getMethod("/category/tree");
        return response;
    } catch (error) {
        console.log("Error: ", error);
        return { success: false, message: error };
    }
}

export const fetchProductDetails = async (id) => {
    try {
        const response = await getMethod(`/products/${id}`);

        if (response.success) {
            return response?.product
        } else {
            return response;
        }
    } catch (error) {
        console.log("Error: ", error);
        return { success: false, message: error }
    }
}

export const fetchRawMaterialCategories = async (search = "") => {
    try {
        const response = await getMethod(
            `/raw-material-category/list?search=${encodeURIComponent(search)}`
        );
        return response;
    } catch (error) {
        return { success: false, message: error };
    }
};

export const fetchRawMaterialVendors = async (search = "", category = "") => {
    try {
        let url = `/raw-material-vendor/list?search=${encodeURIComponent(search)}`;

        if (category) {
            url += `&category=${category}`;
        }

        const response = await getMethod(url);
        return response;
    } catch (error) {
        return { success: false, message: error };
    }
};

export const fetchRawMaterialsList = async (search = "", categorySlug = "") => {
    try {
        const response = await getMethod(
            `/raw-material/list?search=${encodeURIComponent(search)}&categorySlug=${categorySlug}`
        );
        return response;
    } catch (error) {
        return { success: false, message: error };
    }
};

export const fetchRMCategoryProperties = async (id) => {
    try {
        const response = await getMethod(`/raw-material-category/property-definitions/${id}`);
        return response;
    } catch (error) {
        return { success: false, message: error };
    }
}

export const fetchCountries = async () => {
    try {
        const response = await getMethod(`/country/`);
        return response;
    } catch (error) {
        return { success: false, message: error };
    }
};

export const fetchStateByCountry = async (countryId) => {
    try {
        const response = await getMethod(`/state/country/${countryId}`);
        return response;
    } catch (error) {
        return { success: false, message: error };
    }
}

export const fetchCityByState = async (stateId) => {
    try {
        const response = await getMethod(`/city/state/${stateId}`);
        return response;
    } catch (error) {
        return { success: false, message: error };
    }
}

// Fetch vendor item property definitions for a specific vendor
export const fetchVendorItemPropertyDefinitions = async (vendorId) => {
    try {
        const response = await getMethod(`/raw-material-vendor/${vendorId}/property-definitions`);
        return response;
    } catch (error) {
        console.error("Error fetching vendor property definitions:", error);
        return { propertyDefinitions: [] };
    }
};

/**
 * Fetch product component definitions from category
 * GET /api/products/:id/component-definitions
 */
export const fetchCategoryComponentDefinitions = async (productType) => {
    try {
        const response = await getMethod(`/category/${productType}/component-definitions`);
        return response;
    } catch (error) {
        console.error('Error fetching component definitions:', error);
        return { success: false, components: [], message: error.response?.data?.message || error.message };
    }
};

/**
 * Fetch specifications for a specific colorway
 * GET /api/products/:productId/colorways/:colorwayId/specifications
 */
export const fetchColorwaySpecifications = async (productId, colorwayId) => {
    try {
        const response = await getMethod(`/products/${productId}/colorways/${colorwayId}/specifications`);
        return response;
    } catch (error) {
        console.error('Error fetching colorway specifications:', error);
        return { success: false, specifications: null, message: error.response?.data?.message || error.message };
    }
};



/**
 * Fetch common components (shared across all colorways)
 * GET /api/products/:productId/common-components
 */
export const fetchCommonComponents = async (productId) => {
    try {
        const response = await getMethod(`/products/${productId}/common-components`);
        return response;
    } catch (error) {
        console.error('Error fetching common components:', error);
        return { success: false, commonComponents: [], message: error.response?.data?.message || error.message };
    }
};

export const fetchCategoryWithMappings = async (categoryId) => {
    try {
        const response = await getMethod(`/raw-material-category/${categoryId}/with-mappings`);
        console.log('fetchCategoryWithMappings raw response:', response);

        if (response && response.success) {
            return response;
        }

        // Handle case where API returns data directly without success wrapper
        if (response && response.data) {
            return { success: true, data: response.data };
        }

        return { success: false, message: 'Invalid response format' };
    } catch (error) {
        console.error("Error fetching category with mappings:", error);
        return { success: false, message: error.message };
    }
};

export const fetchCategoryTableColumns = async (categoryId) => {
    try {
        const response = await getMethod(`/raw-material-category/${categoryId}/table-columns`);
        return response;
    } catch (error) {
        console.error("Error fetching category table columns:", error);
        return null;
    }
};

export const fetchRawMaterialsByCategory = async (categoryId) => {
    try {
        const response = await getMethod(`/raw-material/list?category=${categoryId}`);
        return response;
    } catch (error) {
        console.error("Error fetching materials by category:", error);
        return { success: false, materials: [] };
    }
};

export const fetchCompatibleVendors = async (params) => {
    try {
        const queryParams = new URLSearchParams(params).toString();
        const response = await getMethod(`/raw-material-vendor/hardware/compatible-vendor?${queryParams}`);
        return response;
    } catch (error) {
        console.error('Error fetching compatible vendors:', error);
        return { success: false, message: error, vendors: [] };
    }
};